import * as React from 'react';
import * as EMPTY_STATE_IMAGE from '../../../../images/icons/empty-states/no-listing-results@2x.png';

export default () =>
  (<div className="align-center mt-2">
    <img
      className="empty-state-icon-medium"
      alt={I18n.t('digitalProductsIndex.emptySearchImgAlt')}
      src={EMPTY_STATE_IMAGE}
    />
    <h3 className="heading-3 normal mt-2">{I18n.t('digitalProductsIndex.emptySearchTitle')}</h3>
   </div>);



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/empty_search.jsx